<template>
    <h1>Create fabric page</h1>
    <button class="appRegularButton" @click="this.$router.push('/profile')">Cancel</button>
</template>